import styled from "styled-components";

export const DropzoneContainer = styled.div<{ $borderColor: any; $textColor: any }>`
    border-width: 2px;
    border-radius: 2px;
    border-color: ${(props) => props.$borderColor};
    border-style: dashed;
    background-color: #EDEDED;
    color: ${(props) => props.$textColor};
    outline: none;
    transition: border .24s ease-in-out;
`;
